import { useIntl } from 'react-intl';
import { InputNumber } from 'ui';
import { StyledDistanceRadiusSelector } from './style';

interface Props {
  controls?: boolean;
}

export const DistanceRadiusSelector = ({ controls = false }: Props) => {
  const intl = useIntl();

  return (
    <StyledDistanceRadiusSelector>
      <div className={'form-title'}>
        {intl.formatMessage({ id: 'form.delivery_distance_title' })}
      </div>
      <InputNumber
        placeholder={intl.formatMessage({
          id: 'form.select_radius_placeholder',
        })}
        name="distance_radius"
        min={1}
        max={1000}
        addonAfter="km"
        controls={controls}
        className={'distance-radius-input'}
      />
    </StyledDistanceRadiusSelector>
  );
};
